import { useSearchFieldContext } from '../context/SearchFieldContext';
import { useFieldsContext } from '../../../contexts';

export const useFields = () => {
  const { aggregateFieldsByDataType } = useFieldsContext();
  const { dataType } = useSearchFieldContext();

  return aggregateFieldsByDataType(dataType);
};
